export default __webpack_public_path__ + "static/media/lawn-doctors-step-2.b4d60dec.jpg";